var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "50CFACC2-D798-454F-8B2D-3832C39BF054") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "User",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard---PLP",
    transform: "translate(-30.000000, -108.000000)",
    fill: "#F88801"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Side-Nav",
    transform: "translate(0.000000, 89.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "dashboard-active",
    transform: "translate(30.000000, 19.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.93745313,0 L1.31245312,0 C0.588726562,0 0,0.588726562 0,1.31245312 L0,4.68745313 C0,5.41132031 0.588726562,6.00004688 1.31245312,6.00004688 L6.93745313,6.00004688 C7.66132031,6.00004688 8.25004688,5.41132031 8.25004688,4.68745313 L8.25004688,1.31245312 C8.25004688,0.588726562 7.66132031,0 6.93745313,0",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.93745313,7.49995312 L1.31245313,7.49995312 C0.588726563,7.49995312 4.4408921e-15,8.08867969 4.4408921e-15,8.81254687 L4.4408921e-15,16.6875469 C4.4408921e-15,17.4112734 0.588726563,18 1.31245313,18 L6.93745313,18 C7.66132031,18 8.25004688,17.4112734 8.25004688,16.6875469 L8.25004688,8.81254687 C8.25004688,8.08867969 7.66132031,7.49995312 6.93745313,7.49995312",
    id: "Fill-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6875469,11.9999531 L11.0625469,11.9999531 C10.3386797,11.9999531 9.74995312,12.5886797 9.74995312,13.3125469 L9.74995312,16.6875469 C9.74995312,17.4112734 10.3386797,18 11.0625469,18 L16.6875469,18 C17.4112734,18 18,17.4112734 18,16.6875469 L18,13.3125469 C18,12.5886797 17.4112734,11.9999531 16.6875469,11.9999531",
    id: "Fill-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6875469,4.4408921e-15 L11.0625469,4.4408921e-15 C10.3386797,4.4408921e-15 9.74995312,0.588726563 9.74995312,1.31245313 L9.74995312,9.18745313 C9.74995312,9.91132031 10.3386797,10.5000469 11.0625469,10.5000469 L16.6875469,10.5000469 C17.4112734,10.5000469 18,9.91132031 18,9.18745313 L18,1.31245313 C18,0.588726563 17.4112734,4.4408921e-15 16.6875469,4.4408921e-15",
    id: "Fill-7"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardActive);
export default __webpack_public_path__ + "static/media/dashboard-active.101610d6.svg";
export { ForwardRef as ReactComponent };